'use strict'

import SliderManager from 'assets/core/js/module/sliderManager'

export default function (): void {
  document.querySelectorAll('.cms__slider').forEach((el) => {
    const id = el.id

    const config = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: `#${id}-next`,
        prevEl: `#${id}-prev`,
      },
      pagination: {
        el: `#${id}-pagination`,
      },
      loop: false,
    }

    // @ts-ignore
    SliderManager.initSlider(`#${id}`, config)
  })
}
